export default "__VITE_ASSET__61001df1__"